import React, { FunctionComponent } from "react";
import { useLocation, useNavigate } from "react-router";

import { LightTooltip } from "components/Tooltip";

import { ReactComponent as PremiumIcon } from "assets/images/icon-premium.svg";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { ListItemButton, Typography } from "./styles";

export interface MenuItemI {
  route: string;
  icon: FunctionComponent;
  name: string;
  premium?: boolean;

  // TODO: remove after feature release
  featureFlag?: string;
}

interface SideMenuItemProps {
  item: MenuItemI;
  premiumText?: string;
  showPremium?: boolean;
  showActive?: boolean;
  isCollapsed?: boolean;
}

const SideMenuItem: React.FC<SideMenuItemProps> = React.memo(
  function SideMenuItem({
    item,
    showPremium,
    premiumText,
    showActive = true,
    isCollapsed = false,
  }) {
    const navigate = useNavigate();
    const { route, icon: Icon, name, premium } = item;

    const location = useLocation();
    const isActive = showActive && location.pathname === route;

    const onItemClick = () => {
      analytics().sendEvent(
        `${AnalyticsEvents.side_menu_}${route.substring(1)}`,
      );
      navigate(route);
    };

    const menuItemContent = (
      <ListItemButton
        onClick={onItemClick}
        selected={isActive}
        isCollapsed={isCollapsed}
        isActive={isActive}
      >
        <Icon />
        <Typography
          variant="body2"
          isCollapsed={isCollapsed}
          isActive={isActive}
        >
          {name}
        </Typography>
        {!isCollapsed && premium && showPremium && (
          <LightTooltip title={premiumText}>
            <PremiumIcon />
          </LightTooltip>
        )}
      </ListItemButton>
    );

    if (!isCollapsed) {
      return menuItemContent;
    }

    return (
      <LightTooltip title={name} placement="right">
        {menuItemContent}
      </LightTooltip>
    );
  },
);

export default SideMenuItem;
